import React, { useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CCardHeader,
  CCardBody,
  CRow,
  CCol,
  CBadge,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CImage,
  CSpinner,
} from "@coreui/react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getDetails } from "src/services/Visitations";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix for default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

function VisitationDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getDetails(id);
        setDetails(res.details);
        setStocks(res.stock);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching visitation details:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <CSpinner color="primary" />
      </div>
    );
  }

  if (!details) {
    return <div>Visitation not found</div>;
  }

  return (
    <div style={{ color: "black" }}>
      <CCard>
        <CCardHeader>
          <CRow className="align-items-center">
            <CCol md={6}>
              <h4>Visitation Details</h4>
            </CCol>
            <CCol md={6} className="text-end">
              <CButton
                color="light"
                onClick={() =>
                  navigate(
                    -1,

                    {
                      state: {
                        page: location.state?.fromPage || 0,
                        pageSize: location.state?.fromPageSize || 10,
                      },
                    }
                  )
                }
              >
                Back to List
              </CButton>
            </CCol>
          </CRow>
        </CCardHeader>

        <CCardBody>
          <CRow>
            <CCol xs={12}>
              {/* Basic Information Section */}
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Basic Information</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={6}>
                      <CTable striped hover responsive>
                        <CTableBody>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Tanggal</CTableHeaderCell>
                            <CTableDataCell>{details.date}</CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Toko</CTableHeaderCell>
                            <CTableDataCell>{details.storeName}</CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Alamat</CTableHeaderCell>
                            <CTableDataCell>{details.storeAddress}</CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Sales</CTableHeaderCell>
                            <CTableDataCell>{details.userName}</CTableDataCell>
                          </CTableRow>
                        </CTableBody>
                      </CTable>
                    </CCol>
                    <CCol md={6}>
                      <CTable striped hover responsive>
                        <CTableBody>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Check In</CTableHeaderCell>
                            <CTableDataCell>
                              {details.check_in || <CBadge color="secondary">Belum check in</CBadge>}
                            </CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Check Out</CTableHeaderCell>
                            <CTableDataCell>
                              {details.check_out || <CBadge color="secondary">Belum check out</CBadge>}
                            </CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Durasi</CTableHeaderCell>
                            <CTableDataCell>{details.duration} menit</CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Status</CTableHeaderCell>
                            <CTableDataCell>
                              <CBadge color={details.check_out ? "success" : details.check_in ? "warning" : "danger"}>
                                {details.check_out
                                  ? "Selesai"
                                  : details.check_in
                                  ? "Sedang Berlangsung"
                                  : "Belum Dimulai"}
                              </CBadge>
                            </CTableDataCell>
                          </CTableRow>
                        </CTableBody>
                      </CTable>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>

              {/* Visibility and Program Section */}
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Visibility & Program</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={6}>
                      <CTable striped hover responsive>
                        <CTableBody>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Visibility</CTableHeaderCell>
                            <CTableDataCell>
                              <CBadge
                                color={
                                  details.visibility === "High"
                                    ? "success"
                                    : details.visibility === "Medium"
                                    ? "warning"
                                    : "danger"
                                }
                              >
                                {details.visibility}
                              </CBadge>
                            </CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Join Program</CTableHeaderCell>
                            <CTableDataCell>
                              <CBadge color={details.is_join_program ? "success" : "secondary"}>
                                {details.is_join_program ? "Ya" : "Tidak"}
                              </CBadge>
                            </CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Comply Program</CTableHeaderCell>
                            <CTableDataCell>
                              <CBadge color={details.is_comply_program ? "success" : "secondary"}>
                                {details.is_comply_program ? "Ya" : "Tidak"}
                              </CBadge>
                            </CTableDataCell>
                          </CTableRow>
                        </CTableBody>
                      </CTable>
                    </CCol>
                    <CCol md={6}>
                      <CTable striped hover responsive>
                        <CTableBody>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Target Program</CTableHeaderCell>
                            <CTableDataCell>{details.program_target}</CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Pencapaian Program</CTableHeaderCell>
                            <CTableDataCell>{details.program_achieved}</CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableHeaderCell scope="row">Aktivasi</CTableHeaderCell>
                            <CTableDataCell>{details.activation}</CTableDataCell>
                          </CTableRow>
                        </CTableBody>
                      </CTable>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>

              {/* Notes and Activities Section */}
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Catatan & Aktivitas</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={6}>
                      <h6>Catatan</h6>
                      <p>{details.notes || <CBadge color="secondary">Tidak ada catatan</CBadge>}</p>
                    </CCol>
                    <CCol md={6}>
                      <h6>Aktivitas Kompetitor</h6>
                      <p>{details.competitor_activity || <CBadge color="secondary">Tidak ada data</CBadge>}</p>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>

              {/* Media Section */}
              <CRow>
                <CCol md={6}>
                  <CCard className="mb-4">
                    <CCardHeader>
                      <strong>Selfie Verification</strong>
                    </CCardHeader>
                    <CCardBody className="text-center">
                      {details.selfie_url ? (
                        <CImage
                          thumbnail
                          src={details.selfie_url}
                          alt="Selfie verification"
                          style={{ maxHeight: "400px" }}
                        />
                      ) : (
                        <CBadge color="secondary">Tidak ada foto selfie</CBadge>
                      )}
                    </CCardBody>
                  </CCard>
                </CCol>

                <CCol md={6}>
                  <CCard className="mb-4">
                    <CCardHeader>
                      <strong>Visibility Photo</strong>
                    </CCardHeader>
                    <CCardBody className="text-center">
                      {details.visibility_url ? (
                        <CImage
                          thumbnail
                          src={details.visibility_url}
                          alt="Visibility photo"
                          style={{ maxHeight: "400px" }}
                        />
                      ) : (
                        <CBadge color="secondary">Tidak ada foto visibility</CBadge>
                      )}
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>

              {/* Location Section */}
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Lokasi Kunjungan</strong>
                </CCardHeader>
                <CCardBody style={{ height: "400px" }}>
                  {details.latitude && details.longitude ? (
                    <MapContainer
                      center={[parseFloat(details.latitude), parseFloat(details.longitude)]}
                      zoom={15}
                      style={{ height: "100%", width: "100%" }}
                    >
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                      <Marker position={[parseFloat(details.latitude), parseFloat(details.longitude)]}>
                        <Popup>
                          {details.storeName}
                          <br />
                          {details.storeAddress}
                        </Popup>
                      </Marker>
                    </MapContainer>
                  ) : (
                    <CBadge color="secondary">Tidak ada data lokasi</CBadge>
                  )}
                </CCardBody>
              </CCard>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Stock Produk</strong>
                </CCardHeader>
                <CCardBody>
                  {/* Stock Availability Summary */}
                  {stocks.length > 0 && (
                    <div className="mb-4">
                      <h5>Ringkasan Ketersediaan Stok</h5>
                      <CRow className="g-3 mb-4">
                        {stocks.map((category) => (
                          <CCol key={`summary-${category.categoryID}`} md={6} lg={3}>
                            <CCard
                              className="h-100"
                              style={{
                                cursor: "pointer",
                                borderLeft: `4px solid ${
                                  category.availabilityPercentage >= 50
                                    ? "#2eb85c"
                                    : category.availabilityPercentage >= 25
                                    ? "#f9b115"
                                    : "#e55353"
                                }`,
                              }}
                              onClick={() => {
                                // Scroll to the category section
                                document.getElementById(`category-${category.categoryID}`)?.scrollIntoView({
                                  behavior: "smooth",
                                });
                              }}
                            >
                              <CCardBody className="p-3">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <h6 className="mb-1">{category.categoryName}</h6>
                                    <small className="text-muted">
                                      {category.availableProducts} dari {category.totalProducts} produk tersedia
                                    </small>
                                  </div>
                                  <CBadge
                                    color={
                                      category.availabilityPercentage >= 50
                                        ? "success"
                                        : category.availabilityPercentage >= 25
                                        ? "warning"
                                        : "danger"
                                    }
                                    shape="rounded-pill"
                                    className="fs-6"
                                  >
                                    {category.availabilityPercentage}%
                                  </CBadge>
                                </div>
                                <div className="mt-2">
                                  <div className="progress" style={{ height: "8px" }}>
                                    <div
                                      className={`progress-bar ${
                                        category.availabilityPercentage >= 50
                                          ? "bg-success"
                                          : category.availabilityPercentage >= 25
                                          ? "bg-warning"
                                          : "bg-danger"
                                      }`}
                                      role="progressbar"
                                      style={{ width: `${category.availabilityPercentage}%` }}
                                      aria-valuenow={category.availabilityPercentage}
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>
                                </div>
                              </CCardBody>
                            </CCard>
                          </CCol>
                        ))}
                      </CRow>
                    </div>
                  )}

                  {/* Detailed Stock Table */}
                  {stocks.length > 0 ? (
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      {stocks.map((category) => (
                        <div key={category.categoryID} id={`category-${category.categoryID}`} className="mb-4">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5>{category.categoryName}</h5>
                            <CBadge color={category.availabilityPercentage >= 50 ? "success" : "warning"}>
                              Ketersediaan: {category.availabilityPercentage}%
                            </CBadge>
                          </div>
                          <CTable striped hover responsive>
                            <CTableHead>
                              <CTableRow>
                                <CTableHeaderCell>Produk</CTableHeaderCell>
                                <CTableHeaderCell>Stock</CTableHeaderCell>
                                <CTableHeaderCell>Status</CTableHeaderCell>
                              </CTableRow>
                            </CTableHead>
                            <CTableBody>
                              {category.products.map((product) => (
                                <CTableRow key={product.productID}>
                                  <CTableDataCell>{product.productName}</CTableDataCell>
                                  <CTableDataCell>
                                    <CBadge color={product.stock > 0 ? "success" : "danger"}>{product.stock}</CBadge>
                                  </CTableDataCell>
                                  <CTableDataCell>
                                    <CBadge color={product.isAvailable ? "success" : "secondary"}>
                                      {product.isAvailable ? "Tersedia" : "Tidak Tersedia"}
                                    </CBadge>
                                  </CTableDataCell>
                                </CTableRow>
                              ))}
                            </CTableBody>
                          </CTable>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <CBadge color="secondary">Tidak ada data stock</CBadge>
                  )}
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </div>
  );
}

export default VisitationDetails;
